import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '@chilecompra/react-kit'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { PUBLIC_URL } from '../../config/settings/environment'
import { Column, Image, LinkHelp, Row } from './HomeForm.styles'

/**
 * The Help's component.
 */
const Help = props => {
  const { onOpenAfterSaleConditions } = props
  const {
    size: { isUpToLarge, isMedium, isDownToSmall, isDownToMedium }
  } = useViewport()

  const paddingCard = useMemo(() => {
    if (isUpToLarge) {
      return '48px 384px'
    }

    if (isMedium) {
      return '48px 192px'
    }

    if (isDownToSmall) {
      return '48px 24px'
    }
  }, [isDownToSmall, isUpToLarge, isMedium])

  return (
    <Card color="blank" padding={paddingCard}>
      <Row justifyContent="center">
        <Column md={2}>
          <Image src={`${PUBLIC_URL}/assets/images/helpIcon.svg`} />
        </Column>
        <Column md={10}>
          <Typography
            align={isDownToMedium ? 'center' : 'left'}
            fontSize="27px"
            fontWeight="bold"
            lineHeight="31px"
            variant="h2"
          >
            ¿Necesitas ayuda con tus pasajes?
          </Typography>
          <Typography
            align={isDownToMedium ? 'center' : 'left'}
            fontSize="16px"
            lineHeight="21px"
            margin="16px 0"
            variant="body1"
          >
            Gestiona y administra cada pasaje adquirido <strong>directamente con la aerolínea</strong> correspondiente.
            En caso de inconvenientes, puedes comunicarte con ellos para recibir asistencia personalizada.
          </Typography>
          <LinkHelp justifyContent={isDownToMedium ? 'center' : 'flex-start'} onClick={onOpenAfterSaleConditions}>
            Conoce las condiciones de la postventa <Image src={`${PUBLIC_URL}/assets/images/chevronRightIcon.svg`} />
          </LinkHelp>
        </Column>
      </Row>
    </Card>
  )
}

Help.propTypes = {
  onOpenAfterSaleConditions: PropTypes.func.isRequired
}

export default Help
